import { create } from 'zustand';

/**
 * 사람 한 명을 여는 **전역 자리** (2026-08-31 · 시안 맞춤 8/9).
 *
 * ★★★ **아바타를 누르는 자리가 여섯인데 넷은 아무 일도 안 했다.** 시안 C3 이 세어 둔 것:
 *    우측 레일 내 아바타(팝오버) · 조직도 팝업 · 채팅 참여자 목록 · **채팅 메시지 아바타** ·
 *    **멘션** · 직원 관리 행 · 우리 조직 행. 이 중 조직도와 참여자만 사람 카드를 열었고,
 *    **대화 중에 「이 사람 누구지」가 가장 잦은 자리**(메시지 아바타)는 눌러도 안 열렸다.
 *
 * ★★ **한 컴포넌트로 연다.** 화면마다 다시 그리면 같은 사람이 두 모습으로 갈라진다 —
 *    `PersonDetailPopup` 하나를 셸(`PersonProfileHost`)이 들고, 여는 쪽은 **userId 만** 준다.
 *    범위(무엇이 보이나)는 서버가 정한다(`GET /hr/people/:id` 의 `scope`).
 *
 * ★ **아는 것만 함께 준다**(`hint`) — 조직에서 그 사람을 못 찾아도(외부 계정·탈퇴) 이름과
 *   사진은 부르는 쪽이 안다. 그러면 팝업이 「못 찾음」 대신 아는 만큼이라도 연다.
 */

/** 부르는 쪽이 이미 아는 값 — 조직 색인이 비어도 팝업이 열리게 한다. */
export interface PersonHint {
  name?: string | null;
  avatarUrl?: string | null;
  position?: string | null;
  email?: string | null;
}

interface PersonProfileState {
  /** 열려 있는 사람. null 이면 아무것도 안 그린다. */
  userId: string | null;
  hint: PersonHint | null;
  open: (userId: string, hint?: PersonHint) => void;
  close: () => void;
}

export const usePersonProfileStore = create<PersonProfileState>((set) => ({
  userId: null,
  hint: null,
  /** ★ 빈 id·AI·시스템 메시지로 열리지 않게 부르는 쪽이 아니라 여기서 한 번 막는다. */
  open: (userId, hint) => {
    if (!userId) return;
    set({ userId, hint: hint ?? null });
  },
  close: () => set({ userId: null, hint: null }),
}));

/** 화면 어디서나 — 훅 밖에서도 부른다(이벤트 핸들러 안에서 쓰기 좋게). */
export function openPersonProfile(userId: string, hint?: PersonHint): void {
  usePersonProfileStore.getState().open(userId, hint);
}
